function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2543 16.7616L13.3351 27.9704C10.0458 27.8225 6.81571 26.4917 4.26723 24.037L12.5054 16.5545L11.2904 15.342L3.94126 23.7116C1.42241 21.1091 0.118534 17.7967 0 14.4547L10.5199 9.84104L13.424 6.73568L11.6163 10.3438L10.6088 10.7579C10.6088 14.2773 13.4536 17.1165 16.98 17.1165L17.5431 16.0518L21.0694 14.2181L18.2543 16.7616ZM23.9143 4.10351C18.4321 -1.36784 9.57163 -1.36784 4.11906 4.10351C1.45204 6.76525 0.0889006 10.1959 0.0296335 13.6858L11.3793 7.71165C12.4757 5.7597 14.5501 4.42884 16.9504 4.42884C20.4768 4.42884 23.3216 7.26802 23.3216 10.7874C23.3216 13.0943 22.077 15.1054 20.2397 16.2292L14.0167 28C17.6023 28 21.1583 26.6396 23.8846 23.9187C29.3668 18.4177 29.3668 9.57486 23.9143 4.10351Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 4.09861,
  y1: 23.8781,
  x2: 23.8608,
  y2: 4.07673,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF95BF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF0166"
})));

var SvgSubscription = function SvgSubscription(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSubscription, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/subscription.b798c9ac.svg";
export { ForwardRef as ReactComponent };